import React from 'react';
import { Link } from 'react-router-dom';

export default function Entry({ value, query = '', variant = 'total' }) {
  const [hover, setHover] = React.useState(false);
  return (
    <td className="status-entry">
      <Link
        to={{
          pathname: '/portfolio',
          search: query
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={cx({
          'translate-hover': hover,
          'cursor-pointer': hover,
          [`variant-${variant}`]: true
        })}
      >
        <span>{value.total}</span>
        <span className="percentage">({(value.ratio * 100).toFixed(0)}%)</span>
      </Link>
    </td>
  );
}

const cx = obj =>
  Object.keys(obj)
    .filter(key => obj[key])
    .join(' ');
